import { Component, input, ChangeDetectionStrategy, ChangeDetectorRef,inject, InputSignal } from '@angular/core';

import { FormsModule } from '@angular/forms';

import { BaseValueAccessor } from '../value-accessor/base-value-accessor';
import { ValueAccessorProviderFactory } from '../value-accessor/value-accessor-provider-factory';
import { SplitButtonComponent } from '../split-buttons/split-button.component';
import { SplitButtonsComponent } from '../split-buttons/split-buttons.component';
import { IconFlagComponent } from '../icon/icon-flag.component';
import { SplitButtonDataComponent } from '../split-buttons/split-button-data.component';

/**
 * The Currency Selector Component
 *
 * This is the button for selecting currency.
 */
@Component({
  imports: [
    FormsModule,
    IconFlagComponent,
    SplitButtonsComponent,
    SplitButtonComponent,
    SplitButtonDataComponent
  ],
  selector: 'td-wb-currency-selector',
  templateUrl: './currency-selector.component.html',
  styleUrls: ['./currency-selector.component.scss'],
  providers: [ValueAccessorProviderFactory(CurrencySelectorComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'tdWbCurrencySelector'
})
export class CurrencySelectorComponent extends BaseValueAccessor<string> {
  readonly codes: InputSignal<Array<string>> = input(['CAD', 'USD']);
  readonly size: InputSignal<string> = input('16x11');
  readonly ariaLabel: InputSignal<string | undefined> = input(undefined, { alias: 'aria-label' });
  readonly ariaLabelledBy: InputSignal<string | undefined> = input(undefined, { alias: 'aria-labelledby' });
  readonly ariaDescribedby: InputSignal<string | undefined> = input(undefined, { alias: 'aria-describedby' });

  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    super();
    this.value = 'CAD';
  }

  /**
   *  BaseValueAccessor.writeValue
   *
   * @param value
   */
  override writeValue(value: string): void {
    super.writeValue(value);
    this.setSelectedCurrency();
    this.changeDetectorRef.markForCheck();
  }

  setSelectedCurrency(): void {
    this.value = this.value === undefined || this.codes().indexOf(this.value) < 0 ? 'CAD' : this.value;
  }
}
